<!-- eslint-disable vue/multi-word-component-names -->
<template>

  <el-row :span="24">
    <el-col :span="24">
      <div class="row m-0">

        <el-row :span="24" class="m-0">
        <el-col
          :span="
            hasGroupBy &&
            timeOfDayGroupByListProp != null &&
            timeOfDayGroupByListProp.length > 0
              ? $vuetify.display.width >= 1200
                ? 8
                : 24
              : $vuetify.display.width >= 500
              ? 24
              : 24
          "
          class="d-flex align-item-center"
          :class="
            $vuetify.display.width < 500
              ? 'x-center mt-2'
              : hasPeriod == true
              ? 'justify-end'
              : ''
          "
        >
          <div class="m-0" >
            <!-- Delete Sessions Filter button -->
            <el-tooltip
              effect="light"
              placement="top"
              show-after="500"
              hide-after="300"
              >
              <template #content >
                  <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Refresh monitoring periods data" }} </span>
              </template>
            <el-button
              v-if="hasCustomDate"
              color="#0D3937"
              class="height-40 border-color-light rounded-3"
              @click="customDate = !customDate"
            >
              <svg class="stroke-icon width-20 height-20">
                <use href="@/assets/svg/icon-sprite.svg#stroke-date"></use>
              </svg>
              <span class="text-white pl-3"> Delete Sessions </span>
            </el-button>
            </el-tooltip>
          </div>
        </el-col>
        </el-row>
      </div>
    </el-col>

    <el-col :span="24">

    <!-- delete session filter -->
    <el-row  class="y-center m-0 p-l-20 py-3">
      <el-col :span="24">
      <div
        class="row y-center mt-2 p-2 bg-me-primary border-color-light rounded-4 width-100-p"
      >

        <el-form :label-position="`top`" class="text-center">
          <el-space
            class="mt-2"
            fill
            style="width: 100%"
            v-if="
              hasCharger ||
              ($store.state.auth.user != null && $store.state.auth.user.is_admin)
            "
          >
            <!-- delete session checkbox -->
            <el-row gutter=20>
              <el-col :span="$vuetify.display.width >= 1200 ? 24 : $vuetify.display.width >= 500 ? 24 : 24">
                <label class="radio-label font-12" :style="{'max-width': $vuetify.display.width <= 1485 ? 'auto' : $vuetify.display.width <= 1578 ? '400px' : $vuetify.display.width <= 1651 ? '450px' : '500px'}">
                  * Please select the method and time period for removing sessions.
                </label>
              </el-col>
              <el-col class="x-center" :span="$vuetify.display.width >= 1200 ? 24 : $vuetify.display.width >= 500 ? 24 : 24">
                <el-radio-group
                  v-model="selectedDeleteBy"
                  label= "Select delete By"
                  class="p-10"
                  >
                  <el-radio label="customer" >Customer</el-radio>
                  <el-radio label="charger" >Charger</el-radio>
                  <el-radio label="site" >Charger Site</el-radio>
                  <el-radio label="port" >Charger Port</el-radio>
                </el-radio-group>
              </el-col>

              <el-col v-if="selectedDeleteBy=='customer'" :span="24" class="x-center mt-20">
                <el-form-item
                  class="label-style"
                  prop="customer"
                  label="Customer : "

                >
                  <el-select
                    clearable
                    v-model="filter.customer_id"
                    placeholder="Select Customer"
                    :style="$vuetify.display.width <= 800 ? 'max-width: 100%; min-width: 200px;' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; min-width: 400px; padding-right: 10px;' : 'max-width: 95%; padding-right: 10px; min-width: 400px;'"
                    class="w-100"
                  >
                    <!-- Render the header row once -->
                  <template v-if="customers.length > 0">
                    <div class="option-content option-header">
                      <span class="option-item">Name</span>
                      <span class="option-item">Phone</span>
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in customers"
                      :key="item.id || index"
                      :label="item.full_name || 'undifined'"
                      :value="item.id || 'undifined'"
                      @click="handleSelectCustomer(item.id, item.full_name)"
                    >
                      <div class="option-content option-row">
                        <span class="option-item">{{ item.full_name }}</span>
                        <span class="option-item">{{ item.phone }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-col>

            <el-row :span="24" class='m-0 p-0 mt-20' style="width: 100%" v-if="selectedDeleteBy !== 'customer'">


              <!-- select customer dropdown -->
              <el-col
                class="pl-0"
                :style="$vuetify.display.width <= 800 ? 'max-width: 100%;' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; padding-right: 10px;' : 'max-width: 95%; padding-right: 10px;'"
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width > 800
                    ? 12
                    : 24
                "
                :offset="$vuetify.display.width >= 1400 ? 4 : 0"
                v-if="
                  hasCustomer &&
                  $store.state.auth.user != null &&
                  $store.state.auth.user.is_admin
                "
              >
                <el-form-item
                  class="label-style"
                  prop="customer"
                  label="Customer : "
                >
                  <el-select
                    clearable
                    v-model="filter.customer_id"
                    placeholder="Select Customer"
                    class="w-100"
                  >
                    <!-- Render the header row once -->
                  <template v-if="customers.length > 0">
                    <div class="option-content option-header">
                      <span class="option-item">Name</span>
                      <span class="option-item">Phone</span>
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in customers"
                      :key="item.id || index"
                      :label="item.full_name || 'undifined'"
                      :value="item.id || 'undifined'"
                      @click="handleSelectCustomer(item.id, item.full_name)"
                    >
                      <div class="option-content option-row">
                        <span class="option-item">{{ item.full_name }}</span>
                        <span class="option-item">{{ item.phone }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- select customer dropdown end -->
              </el-col>


              <!-- select chargers dropdown -->
              <el-col
                v-if="hasCharger"
                :style="$vuetify.display.width <= 800 ? 'max-width: 100%;' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; padding-left: 10px;' : 'max-width: 95%; padding-left: 10px;'"
                class="pr-0"
                :class="
                  $store.state.auth.user == null ||
                  !$store.state.auth.user.is_admin
                    ? 'pl-0'
                    : ''
                "
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width <= 800
                    ? 24
                    : 12
                "
              >
              <div >
                <el-form-item
                  class="label-style"
                  prop="charger"
                  :style="$vuetify.display.width < 500 ? '' : ''"
                  :label="selectedDeleteBy === 'port' ? 'Charger Ports: ' : selectedDeleteBy === 'site' ? 'Charger Sites: ' : selectedDeleteBy === 'charger' ? 'Chargers: ' : 'Select Delete By'"
                >
                  <el-select
                    v-if="selectedDeleteBy == `charger`"
                    v-model="filter.charger_name"
                    class="w-100"
                    :style="{'max-width': $vuetify.display.width <= 630 ? '320px' : ''}"
                    filterable
                    clearable
                    :loading="chargerLoading"
                    placeholder="Select Charger (search by charger name)"
                    :width="
                    $vuetify.display.width >= 1400
                      ? '100%'
                      : $vuetify.display.width <= 700
                      ? '60%'
                      : '100%'"
                  >
                  <template v-if="chargers.length > 0">
                    <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                      <span class="option-item">Charger Name</span>
                      <span class="option-item">Site Name</span>
                      <span class="option-item">Operational Date</span>
                    </div>
                  </template>

                  <el-option
                      :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                      v-for="(item, index) in chargers_dropdown"
                      :key="item.charger_id || index"
                      :label="item.charger_name || 'undifined'"
                      :value="item.charger_id || 'undifined'"
                      @click="handleSelectCharger(item.charger_site_id, item.site_name, item.charger_name, item.charger_id)"
                    >
                      <div class="option-content option-row"                     :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                        <span class="option-item">{{ item.charger_name }}</span>
                        <span class="option-item">{{ item.site_name.length > 15 ? item.site_name.substring(0, 15) : item.site_name }}</span>
                        <span class="option-item">{{ item.operational_date }}</span>
                      </div>
                    </el-option>
                  </el-select>

                  <el-select
                    v-if="this.selectedDeleteBy == 'port'"
                    v-model="filter.charger_name"
                    class="w-100"
                    :style="{'max-width': $vuetify.display.width <= 630 ? '320px' : ''}"
                    filterable
                    clearable
                    :loading="portLoading"
                    placeholder="Select Charger Port (search by port name)"
                    :width= "$vuetify.display.width >= 1400
                      ? '100%'
                      : $vuetify.display.width <= 700
                      ? '60%'
                      : '100%'"
                  >
                  <template v-if="chargers.length > 0">
                    <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                      <span class="option-item">Port Name</span>
                      <span class="option-item">Site Name</span>
                      <span class="option-item">Charger Name</span>
                      <span class="option-item">Operational Date</span>
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in charger_ports_dropdown"
                      :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                      :key="item.unique_port_id || index"
                      :label="item.port_id || 'undifined'"
                      :value="item.unique_port_id || 'undifined'"
                      @click="handleSelectCharger(item.charger_site_id, item.site_name, item.charger_name, item.charger_id, item.unique_port_id)"
                    >
                      <div class="option-content option-row"  :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                        <span class="option-item">{{ item.port_id }}</span>
                        <span class="option-item">{{ item.site_name.length > 15 ? item.site_name.substring(0, 15) : item.site_name }}</span>
                        <span class="option-item">{{ item.charger_name }}</span>
                        <span class="option-item">{{ item.operational_date }}</span>
                      </div>
                    </el-option>
                  </el-select>

                  <el-select
                    v-if="this.selectedDeleteBy == 'site'"
                    v-model="filter.charger_name"
                    class="w-100"
                    :style="{'max-width': $vuetify.display.width <= 630 ? '320px' : ''}"
                    filterable
                    clearable
                    :loading="siteLoading"
                    placeholder="Select Charger Site (search by site name)"
                    :width= "$vuetify.display.width >= 1400
                      ? '100%'
                      : $vuetify.display.width <= 700
                      ? '60%'
                      : '100%'"
                  >
                  <template v-if="chargers.length > 0">
                    <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                      <span class="option-item">Site Name</span>
                          <span class="option-item">State</span>
                          <span class="option-item">Suburb</span>
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in charger_sites_dropdown"
                      :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                      :key="item.unique_charger_id || index"
                      :label="item.site_name || 'undifined'"
                      :value="item.unique_charger_id || 'undifined'"
                      @click="handleSelectCharger(item.charger_site_id, item.site_name, item.charger_name, item.charger_id, item.unique_port_id, item.unique_charger_id)"
                    >
                      <div class="option-content option-row" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                        <span class="option-item">{{ item.site_name.length > 15 ? item.site_name.substring(0, 15) : item.site_name }}</span>
                          <span class="option-item">{{ item.state }}</span>
                          <span class="option-item">{{ item.suburb.length > 15 ? item.suburb.substring(0, 15) : item.suburb }}</span>
                      </div>

                    </el-option>
                  </el-select>


                </el-form-item>
              </div>
              </el-col>
              </el-row>
              <el-col v-if="showMP" :span="24">
                <el-radio-group
                  v-model="selectTimePeriod"
                  label= "Select Time Period"
                  class="p-10"
                  >
                  <!-- <el-radio :disabled="!showCMP" label="current_mp" @click="switchTimePeriod('current_mp')">Current MP</el-radio>
                  <el-radio :disabled="!showRMP" label="revision_mp" @click="switchTimePeriod('revision_mp')">Revision MP</el-radio> -->
                  <el-radio  label="current_mp" @click="switchTimePeriod('current_mp')">Pre-Audit MP</el-radio>
                  <el-radio label="revision_under_audit_mp" @click="switchTimePeriod('revision_under_audit_mp')">Revision Under Audit MP</el-radio>
                  <el-radio label="revision_issue_requested_mp" @click="switchTimePeriod('revision_issue_requested_mp')">Revision Issue Requested MP</el-radio>
                </el-radio-group>
              </el-col>

              <!-- select charger dropdown end -->
            </el-row>
          </el-space>

          <!-- delete session datetime picker -->
          <el-space v-if="!showMP" fill style="width: 100%">
            <div>
              <span v-if="!showCMP" class="warning-message">Warning: There is not any current monitoring period in the database.</span><br/>
              <span v-if="!showRMP" class="warning-message">Warning: There is not any revision monitoring period in the database.</span>
            </div>
          </el-space>
          <el-space v-if="showMP" fill style="width: 100%">
            <div>
              <span v-if="!showCMP && showCMPwarning" class="warning-message">Warning: There is not any current monitoring period in the database.</span><br/>
              <span v-if="!showRMP && showRMPwarning" class="warning-message">Warning: There is not any revision monitoring period in the database.</span>
            </div>
            <el-row v-if="showTimePicker" gutter=20>
              <el-col

                :class="$vuetify.display.width <= 500 ? 'px-0' : 'pl-0'"
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width <= 500
                    ? 24
                    : 12
                "
                :offset="$vuetify.display.width >= 1400 ? 4 : 0"
              >
                <el-form-item class="label-style mb-1" label="Start Date : ">
                  <el-date-picker
                    v-model="tempStartDate"
                    type="datetime"
                    placeholder="Pick a start date and time"
                    size="default"
                    class="w-100"
                    format="DD/MM/YYYY HH:mm:ss"
                    date-format="DD/MM/YYYY"
                    time-format="HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="updateDate('start')"
                    @cancel="resetTempDate('start')"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :class="$vuetify.display.width <= 500 ? 'px-0 pt-10' : 'pr-0'"
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width <= 500
                    ? 24
                    : 12
                "
              >
                <el-form-item class="label-style mb-1" label="End Date : ">
                  <el-date-picker
                    v-model="tempEndDate"
                    type="datetime"
                    placeholder="Pick a end date and time"
                    size="default"
                    class="w-100"
                    format="DD/MM/YYYY HH:mm:ss"
                    date-format="DD/MM/YYYY"
                    time-format="HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="updateDate('end')"
                    @cancel="resetTempDate('end')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-space>

        </el-form>

        <!-- delete submite button -->
        <el-row v-if="showMP && showTimePicker" gutter=20 class="float-right mt-5 width-100-p">
          <el-col
            :span="$vuetify.display.width >= 700 ? 12 : 24"
            :offset="$vuetify.display.width >= 1400 ? 4 : 0"
            class="px-1 y-center height-50"
            :class="$vuetify.display.width < 700 ? 'py-2 x-end' : 'height-100-p'"
          >
            <el-button
                @click="handleDeleteSession"
                class="custom-filter-button-apply"
            >
            <svg class="width-112 height-40">
                <use
                    href="@/assets/svg/newSvgIcon.svg#tableDeleteButton"
                ></use>
                </svg>
            </el-button>
          </el-col>
        </el-row>
      </div>
      </el-col>

    </el-row>
    </el-col>

  </el-row>





</template>

<script>
  import UserService from "@/services/user.service";
  import { ElMessageBox } from "element-plus";
  import userService from "@/services/user.service";


  export default {

    components: {

    },


    props: {
      customerData: {
        type: Array,
        default: null,
      },
      monitoringPeriods: {
        type: Array,
        default: null,
      },
      propCardData: {
        type: Object,
        default: null,
      },
      stateProp: {
        type: Array,
        default: null,
      },
      timeOfDayGroupByListProp: {
        type: Array,
        default: null,
      },
      hasGroupBy: {
        type: Boolean,
        default: false,
      },
      hasPeriod: {
        type: Boolean,
        default: false,
      },
      hasCustomDate: {
        type: Boolean,
        default: false,
      },
      hasLocation: {
        type: Boolean,
        default: false,
      },
      hasCharger: {
        type: Boolean,
        default: false,
      },
      hasCustomer: {
        type: Boolean,
        default: true,
      },
      periodNameProp: {
        type: String,
        default: "All",
      },
    },

    watch: {
      'monitoringPeriods' : {
        handler: function(newVal) {
          this.fromParentMonitoringPeriods = newVal;
          // Only call fetchMonitoringPeriod if we have valid data
          if (newVal && newVal.data && newVal.data.monitoring_periods) {
            this.$nextTick(() => {
              this.fetchMonitoringPeriod();
            });
          }
        },
        immediate: true,
        deep: true,
      },
      'customerData' : {
        handler: function(newVal) {
          this.fromParentCustomerData = newVal;
          if (newVal && newVal.data && newVal.data.customers) {
            this.customer_chargers = [];
            this.$nextTick(() => {
                this.fetchCustomerData();
            });
          }
        },
        immediate: true,
        deep: true,
      },
      // reset datetime range when above limite period
      'deleteByDatetime.startDate'(newVal) {

        if(newVal < this.filter.startDate) {
          this.deleteByDatetime.startDate = this.filter.startDate;
          this.tempStartDate = this.filter.startDate;
          let MessageBox = `
          <span class="moderat-meGreen">Start date cannot be before the start of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.startDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal > this.filter.endDate) {
          this.deleteByDatetime.startDate = this.filter.startDate;
          this.tempStartDate = this.filter.startDate;
          let MessageBox = `
          <span class="moderat-meGreen">Start date cannot be after the end of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.endDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal == null) {
          this.deleteByDatetime.startDate = this.filter.startDate;
          this.tempStartDate = this.filter.startDate;
        }
      },
      'deleteByDatetime.endDate'(newVal){
        if(newVal > this.filter.endDate) {
          this.deleteByDatetime.endDate = this.filter.endDate;
          this.tempEndDate = this.filter.endDate;
          let MessageBox = `
          <span class="moderat-meGreen">End date cannot be after the end of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.endDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal < this.filter.startDate) {
          this.deleteByDatetime.endDate = this.filter.endDate;
          this.tempEndDate = this.filter.endDate;
          let MessageBox = `
          <span class="moderat-meGreen">End date cannot be before the start of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.startDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal == null) {
          this.deleteByDatetime.endDate = this.filter.endDate;
          this.tempEndDate = this.filter.endDate;
        }
      },
      // reset datetime range when above limite period

      'selectedCustomer.customer_id': {
            handler: "updateChargerList",
            deep: true,
          },

      'customDate'(newVal) {
        if(!newVal) {
          this.resetAll();
        }
        if(newVal) {
          this.fetchMonitoringPeriod();
        }
      },

      'selectedDeleteBy'(newVal) {
        // console.log("newVal select delete by", newVal);

        this.$emit("showchildDropdownTable", false);

        if(newVal == "charger") {
          this.switchChargerDropdownData('charger');
        }
        if(newVal == "site") {
          this.switchChargerDropdownData('site');
        }
        if(newVal == "port") {
          this.switchChargerDropdownData('port');
        }
      }
    },

    computed: {
      selectedChargerInfo() {
        // console.log("this.chargers", this.chargers);
        // console.log("this.selecteddeleteBy", this.selectedDeleteBy);
        let type = this.selectedDeleteBy;
        let data = [];
        if(type == "charger") {
          data = this.chargers.filter(
            (item) => item.charger_id == this.selectedChargerName.charger_id
          );
        }
        if(type == "port") {
          data = this.chargers.filter(
            (item) => item.unique_port_id == this.selectedChargerName.unique_port_id
          );
        }
        if(type == "site") {
          data = this.chargers.filter(
            (item) => item.charger_site_id == this.selectedChargerName.charger_site_id
          );
        }
        return data;

        // return this.chargers.filter(
        //   (item) => item.charger_id == this.selectedChargerName.charger_id
        // );
      },
      tableColumns() {
        if(this.selectedChargerInfo.length > 0) {
          const columns = Object.keys(this.selectedChargerInfo[0]).map(item => {
            return {
              prop: item,
              label: this.formatTableLabel(item),
            };
          });
          return columns;
        } else {
          return [];
        }
      },

      showTimePicker(){
        if(this.selectTimePeriod === ''){
          return false
        } else if(this.showCMP && !this.showRMPwarning) {
          return true
        } else if(this.showRMP && !this.showCMPwarning) {
          return true
        } else {
          return false
        }
      }

    },

    data() {
      return {

        showMP: false,
        showCMP: false,
        showRMP: false,

        showRMPwarning: false,
        showCMPwarning: false,


        allInOneChargerData: null,

        fromParentMonitoringPeriods: null,
        fromParentCustomerData: null,

        fetchedTimePeriod: [],

        checkDelete: false,

        // radio select delete by charger, site, port
        selectedDeleteBy: 'charger', // default selected delete by charger

        // radio select time period
        selectTimePeriod: '', // default selected time period

        customDate: false,
        states: ["All"],

        customers: [], //customer dropdown list

        chargers: [], // charger dropdown list

        customer_chargers: [],
        customer_charger_ports: [],
        customer_charger_sites: [],

        chargers_dropdown: [],
        charger_ports_dropdown: [],
        charger_sites_dropdown: [],


        defaultTimeStart: null,
        defaultTimeEnd: null,

        // selected customer from first dropdown
        selectedCustomer: {
            customer_id: null,
            full_name: null,
        },
        // selected charger from second dropdown
        selectedChargerName: {
            charger_id: null, // unique charger id for delete

            charger_site_id: null,
            charger_site_name: null,
            charger_name: null,

            unique_port_id: null, // unique port id for delete

            unique_site_id: null, // unique site id for delete
        },

        deleteAll: {
          uniq_charger_id: null,
          startDate: null,
          endDate: null,
        },

        tempStartDate: null,
        tempEndDate: null,

        deleteByDatetime: {
          startDate: null,
          endDate: null,
          uniq_charger_id: null,
        },

        deleteRequest: null,

        filter: {
          customer_id: null,
          state: "All",
          startDate: null,
          endDate: null,
          groupBy: null,
          groupByItem: null,
          charger_name: null,
        },
        // groupByItems: [
        //   { key: "all", title: "All" },
        //   { key: "suburb", title: "By Suburb" },
        //   { key: "elec_region", title: "By Electricity Region" },
        //   { key: "charging_site", title: "By Charging Site" },
        //   { key: "post_code", title: "By Postcode" },
        // ],
        // byList: [],
        chargerLoading: false,
        portLoading: false,
        siteLoading: false,
      };
    },
    mounted() {
        this.resetAll();
    },
      methods: {
        updateDate(type) {
          if(type == 'start') {
            this.deleteByDatetime.startDate = this.tempStartDate; // Set the actual startDate
            console.log("Start date updated:", this.deleteByDatetime.startDate);
          } else if(type == 'end') {
            this.deleteByDatetime.endDate = this.tempEndDate; // Set the actual endDate
            console.log("End date updated:", this.deleteByDatetime.endDate);
          }
        },


      resetTempDate(type) {
        if(type == 'start') {
          this.tempStartDate = this.filter.startDate;
        } else if(type == 'end') {
          this.tempEndDate = this.filter.endDate;
        }
      },

      formatTableLabel(label) {

        let splitLabel = label.toLowerCase().split("_");
        for (let i = 0; i < splitLabel.length; i++) {
          splitLabel[i] = splitLabel[i].replace(/\b\w/g, char => char.toUpperCase());
        }
        label = splitLabel.join(" ");
        return label.replaceAll('Port Capacity Kw', 'Port Capacity (kW)');
        },


      /**
       * Switches the time period based on the selected event and updates the filter and deleteByDatetime dates.
       *
       * Description:
       * - Logs the event to the console for debugging purposes.
       * - Switches the time period based on the event type ("current_mp" or "revision_mp").
       * - Updates the `filter` and `deleteByDatetime` objects with the corresponding start and end dates from the `fetchedTimePeriod` array.
       *
       * @param {string} event - The event type indicating the time period to switch to (e.g., "current_mp", "revision_mp").
       */
      switchTimePeriod(event) {
        this.showCMPwarning = false;
        this.showRMPwarning = false;
        // console.log(event);
        switch (event) {
          case "current_mp":
            this.showCMPwarning = true;
            if (this.showCMP) {
              this.filter.startDate = this.fetchedTimePeriod.find(item => item.type == "current_mp").start_date;
              this.filter.endDate = this.fetchedTimePeriod.find(item => item.type == "current_mp").end_date;
              this.tempStartDate = this.fetchedTimePeriod.find(item => item.type == "current_mp").start_date;
              this.tempEndDate = this.fetchedTimePeriod.find(item => item.type == "current_mp").end_date;
              this.updateDate("start");
              this.updateDate("end");
            } else {
              this.filter.startDate = null;
              this.filter.endDate = null;
              this.tempStartDate = null;
              this.tempEndDate = null;
              this.updateDate("start");
              this.updateDate("end");
            }
            break;
          case "revision_under_audit_mp":
            this.showRMPwarning = true;
            if (this.showRMP) {
            this.filter.startDate = this.fetchedTimePeriod.find(item => item.type == "revision_under_audit_mp").start_date;
            this.filter.endDate = this.fetchedTimePeriod.find(item => item.type == "revision_under_audit_mp").end_date;
            this.tempStartDate = this.fetchedTimePeriod.find(item => item.type == "revision_under_audit_mp").start_date;
            this.tempEndDate = this.fetchedTimePeriod.find(item => item.type == "revision_under_audit_mp").end_date;
            this.updateDate("start");
            this.updateDate("end");
            } else {
              this.filter.startDate = null;
              this.filter.endDate = null;
              this.tempStartDate = null;
              this.tempEndDate = null;
              this.updateDate("start");
              this.updateDate("end");
            }
            break;
          case "revision_issue_requested_mp":
            this.showRIPwarning = true;
            if (this.showRIP) {
            this.filter.startDate = this.fetchedTimePeriod.find(item => item.type == "revision_issue_requested_mp").start_date;
            this.filter.endDate = this.fetchedTimePeriod.find(item => item.type == "revision_issue_requested_mp").end_date;
              this.tempStartDate = this.fetchedTimePeriod.find(item => item.type == "revision_issue_requested_mp").start_date;
              this.tempEndDate = this.fetchedTimePeriod.find(item => item.type == "revision_issue_requested_mp").end_date;
              this.updateDate("start");
              this.updateDate("end");
            } else {
              this.filter.startDate = null;
              this.filter.endDate = null;
              this.tempStartDate = null;
              this.tempEndDate = null;
              this.updateDate("start");
              this.updateDate("end");
            }
            break;
          default:
            break;
        }
      },

        // handleDeleteSession
        /**
         * Handles the deletion of sessions based on the selected charger type and date range.
         *
         * Description:
         * - Determines the type of deletion (charger, site, or port) and constructs the `deleteRequest` object accordingly.
         * - Displays a confirmation dialog to the user, asking if they want to proceed with the deletion.
         * - If the user confirms, calls the `submitDelete` method to perform the deletion.
         * - If the user cancels, logs a message indicating that the deletion was cancelled.
         *
         * @returns {Promise<void>} - A promise that resolves when the deletion process is completed.
         */
        async handleDeleteSession() {

            let type = this.selectedDeleteBy;

            switch (type) {
              case "customer":
                this.deleteRequest={
                  type: "customer",
                  customer_id: this.selectedCustomer.customer_id,
                  uniq_charger_id: this.selectedCustomer.customer_id,
                  startDate: this.deleteByDatetime.startDate,
                  endDate: this.deleteByDatetime.endDate,
                }
                break;
              case "charger":
                this.deleteRequest={
                  type: "charger",
                  customer_id: this.selectedCustomer.customer_id,
                  uniq_charger_id: this.selectedChargerName.charger_id,
                  startDate: this.deleteByDatetime.startDate,
                  endDate: this.deleteByDatetime.endDate,
                }
                break;
              case "site":
                this.deleteRequest={
                    type: "site",
                    customer_id: this.selectedCustomer.customer_id,
                    charger_site_id: this.selectedChargerName.charger_site_id,
                    uniq_charger_id: this.selectedChargerName.unique_site_id,
                    startDate: this.deleteByDatetime.startDate,
                    endDate: this.deleteByDatetime.endDate,
                  }
                break;
              case "port":
                this.deleteRequest={
                  type: "port",
                  customer_id: this.selectedCustomer.customer_id,
                  uniq_charger_id: this.selectedChargerName.unique_port_id,
                  startDate: this.deleteByDatetime.startDate,
                  endDate: this.deleteByDatetime.endDate,
                }
                break;
              default:
                break;
            }




            // console.log("this.filter", this.filter);
            if(this.selectedDeleteBy == "customer") {
              let MessageBox = `
              <span class="moderat-meGreen">Do you want to proceed with deleting sessions for customer:</span>
              <span class="moderat-meGreen">${this.selectedCustomer.full_name}?</span><br>`;
              return ElMessageBox.confirm(
                MessageBox,
                "confirm",
                {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel",
                  dangerouslyUseHTMLString: true,
                }
              ).then(() => {
                this.submitDelete();
              }
              ).catch(() => {
                console.log("Delete cancelled");
              });

            } else {

              let MessageBox = `
              <span class="moderat-meGreen">Do you want to proceed with deleting sessions for ${this.selectedDeleteBy} of </span>
              <span class="moderat-meGreen">${this.selectedDeleteBy == "charger" ? 'charger name: ' + this.selectedChargerName.charger_name : this.selectedDeleteBy == "site" ? 'site name: ' + this.selectedChargerName.site_name : this.selectedDeleteBy == "port" ? 'charger name: ' + this.selectedChargerName.charger_name : this.selectedChargerName.charger_name}?</span><br>`;
              return ElMessageBox.confirm(
                MessageBox,
                'Confirm',
                {
                  distinguishCancelAndClose: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'Cancel',
                  dangerouslyUseHTMLString: true,
                }
              ).then(() => {
                this.submitDelete();
              }
              ).catch(() => {
                console.log("Delete cancelled");
              });
            }
        },

        // submiteDelete
        /**
         * Submits the delete sessions request.
         *
         * Description:
         * - Displays an initial alert indicating that the delete request has been submitted.
         * - Sends a request to delete sessions by unique charger ID using the `deleteRequest` object.
         * - If the deletion is unsuccessful, displays an error alert with the result message.
         * - If the deletion is successful, displays a success alert with detailed information about the deletion.
         * - Resets the form and emits an `afterDelete` event upon successful deletion.
         * - Logs any errors that occur during the delete operation and displays an error alert.
         *
         * @returns {Promise<void>} - A promise that resolves when the delete operation is completed.
         */
        async submitDelete() {

          try {

            let MessageBox = `
            <span class="moderat-meGreen">Delete request submitted!</span>`;
            await ElMessageBox.alert(
              MessageBox,
              {
                confirmButtonText: "OK",
                type: "success",
                dangerouslyUseHTMLString: true,
              }
            ).then().catch(()=>{return;});

            // console.log("submit delete");

            let result = null;

            const res = await userService.DeleteSessionsByUniqueChargerId(this.deleteRequest);
            result = res.data;
            // console.log("result", result);

            if (!result.success) {
              let MessageBox = `
              <span class="moderat-meGreen">${result.message}</span>`;
              await ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(()=>{return;});

            } else {
              let MessageBox = `
              <span class="moderat-meGreen">${result.message}</span><br>
              <span class="moderat-meGreen">${result.type}</span>`;
              await ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "success",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(()=>{return;});

            this.resetAll();
            this.$emit("afterDelete");

            }

          } catch (error) {
            console.error("An error occurred during the delete operation.", error);
            let MessageBox = `
            <span class="moderat-meGreen">An error occurred during the delete operation. Please try again.</span>`;
            ElMessageBox.alert(
              MessageBox,
              {
                confirmButtonText: "OK",
                type: "error",
                dangerouslyUseHTMLString: true,
              }
            ).then().catch(()=>{return;});
          }
        },

        // handleReset
        resetAll() {
            this.chargers = [];
            this.selectedCustomer.customer_id = null;
            this.selectedCustomer.full_name = null;
            this.selectedChargerName.charger_id = null;
            this.selectedChargerName.charger_name = null;

            this.deleteAll.uniq_charger_id = null;
            this.deleteByDatetime.uniq_charger_id = null;
            this.deleteByDatetime.startDate = null;
            this.deleteByDatetime.endDate = null;

            this.filter = {
              customer_id: null,
              state: "All",
              startDate: null,
              endDate: null,
              groupBy: null,
              groupByItem: null,
              charger_name: null,
            };

            this.fetchedTimePeriod = [];
            this.$emit("showchildDropdownTable", false);

            this.fetchMonitoringPeriod();
            this.selectTimePeriod = '';
        },

        // handleSelectCustomer
        /**
         * Handles the selection of a customer.
         * @param {number} id - The ID of the selected customer.
         * @param {string} name - The full name of the selected customer.
         * Description:
         * - If the `id` is null, logs a message indicating that no customer ID was found.
         * - Sets the `customer_id` and `full_name` of `selectedCustomer` to the provided `id` and `name`.
         */
        async handleSelectCustomer(id, name) {
          if (id == null) {
            console.log("no customer id found");
          }
          this.selectedCustomer.customer_id = id;
          this.selectedCustomer.full_name = name;

          this.filter.charger_name = null;


          // console.log(this.selectedCustomer);

          let foundCharger = this.customer_chargers.find((item) => item.customer_id == id);
          if (!foundCharger) {
            // await this.fetchChargerData(id);
            await this.fetchAllInOneChargerData(id);
          } else {
            await this.processChargerData(id, this.allInOneChargerData);
          }




          // fetch charger data to update charger list after selecting customer

        },


        // handleSelectCharger
        /**
         * Handles the selection of a charger and updates the selected charger information.
         *
         * Description:
         * - Resets and updates the selected charger information based on the provided parameters.
         * - Emits events to update the parent component with the selected charger information, table columns, and to show the child dropdown table.
         *
         * @param {string} charger_site_id - The ID of the charger site.
         * @param {string} site_name - The name of the site.
         * @param {string} charger_name - The name of the charger.
         * @param {string} charger_id - The ID of the charger.
         * @param {string} unique_port_id - The unique ID of the port.
         * @param {string} unique_site_id - The unique ID of the site.
         * @returns {Promise<void>} - A promise that resolves when the charger information is updated and events are emitted.
         */
        async handleSelectCharger(charger_site_id, site_name, charger_name, charger_id, unique_port_id, unique_site_id) {

          // charger
          // reset selected charger id
          this.selectedChargerName.charger_id = charger_id;
          // update required request data
          this.selectedChargerName.charger_site_id = charger_site_id;
          this.selectedChargerName.site_name = site_name;
          this.selectedChargerName.charger_name = charger_name;

          // port
          this.selectedChargerName.unique_port_id = unique_port_id;

          // site
          this.selectedChargerName.unique_site_id = unique_site_id;

          // console.log("selected charger", charger_site_id, site_name, charger_name, charger_id, unique_port_id, unique_site_id);

          this.$emit("selectedChargerInfo", this.selectedChargerInfo);
          this.$emit("tableColumns", this.tableColumns);
          this.$emit("showchildDropdownTable", true);


        },

        /**
         * Switches the charger dropdown data based on the selected event type.
         *
         * Description:
         * - Gets the selected customer ID.
         * - If the customer ID is not null:
         *   - Tries to switch the dropdown data based on the event type.
         *   - Updates the `chargers`, `chargers_dropdown`, `charger_sites_dropdown`, or `charger_ports_dropdown` arrays accordingly.
         * - Handles errors by logging them.
         * - If the customer ID is null, logs a message indicating that no customer ID was found and clears the `chargers` array.
         *
         * @param {string} event - The event type (e.g., "charger", "site", "port").
         * @returns {Promise<void>} - A promise that resolves when the dropdown data is switched.
         */
        async switchChargerDropdownData(event) {

          // get selected customer id
          let id = this.selectedCustomer.customer_id;

          if (id != null) {
            // this.chargers = [];

            try {

              switch (event) {

                case "charger":
                  this.chargers = this.customer_chargers.find((item) => item.customer_id == id).chargers;
                  this.chargers_dropdown = this.chargers.map((item) => {
                    return {
                      charger_id: item.charger_id,
                      charger_name: item.charger_name,
                      site_name: item.site_name,
                      operational_date: item.operational_date,
                    };
                  });
                  break;
                case "site":
                  this.chargers = this.customer_charger_sites.find((item) => item.customer_id == id).charger_sites;
                  this.charger_sites_dropdown = this.chargers.map((item) => {
                    return {
                      charger_site_id: item.charger_site_id,
                      unique_charger_id: item.unique_charger_id,
                      site_name: item.site_name,
                      state: item.state,
                      suburb: item.suburb,
                    };
                  });
                  // console.log("chargers", this.chargers);

                  // console.log("charger_sites_dropdown", this.charger_sites_dropdown);

                  break;
                case "port":
                  this.chargers = this.customer_charger_ports.find((item) => item.customer_id == id).charger_ports;
                  this.charger_ports_dropdown = this.chargers.map((item) => {
                    return {
                      unique_port_id: item.unique_port_id,
                      port_id: item.port_id,
                      site_name: item.site_name,
                      charger_name: item.charger_name,
                      operational_date: item.operational_date,
                    };
                  });
                  break;
                default:
                  break;
              }
              } catch (error) {
                console.log(error);
              }

        } else {
          console.log("no customer id found");
          this.chargers = [];
        }

        },



      // fetchMonitoringPeriod for selected start and end date dropdown
      /**
       *
       * Fetches the current monitoring period and updates the filter and deleteByDatetime dates.
       *
       * Description:
       * - Sends a request to fetch monitoring periods.
       * - Filters the response data to find the 'current monitoring period'.
       * - Updates the `filter` and `deleteByDatetime` objects with the start and end dates of the current monitoring period, appending "00:00:00" to the start date and "23:59:59" to the end date.
       *
       */

       async fetchMonitoringPeriod() {

        try {
          const requestData = [];

          // const monitoringPeriodsRes = await userService.getMonitoringPeriods(null, "", 1, 50, true);
          const monitoringPeriodsRes = this.fromParentMonitoringPeriods;

          // Check if we have valid data before proceeding
          if (!monitoringPeriodsRes || !monitoringPeriodsRes.data || !monitoringPeriodsRes.data.monitoring_periods) {
            console.log("No monitoring periods data available yet, skipping fetchMonitoringPeriod");
            return;
          }

          requestData.push({
            "table_name": "monitoring_periods",
            "data": monitoringPeriodsRes.data.monitoring_periods,
          });

          let filtData = requestData[0].data.filter((item) => item.status_display == "Pre-Audit (Current MP)" && item.status == "current");
          let filtDataTwo = requestData[0].data.filter((item) => item.status_display == "Revision Under Audit" && item.status == "revision_under_audit");
          let filtDataThree = requestData[0].data.filter((item) => item.status_display == "Revision Issue Requested" && item.status == "revision_issue_requested");

          let errorMessage = '';

          if (filtData.length === 0) {
            this.showCMP = false;
            errorMessage += "Current Monitoring Period not found. ";
          }

          if (filtDataTwo.length === 0) {
            this.showRMP = false;
            errorMessage += "Revision Monitoring Period not found.";
          }

          if (filtDataThree.length === 0) {
            this.showRIP = false;
            errorMessage += "Revision Issue Requested Monitoring Period not found.";
          }

          if (errorMessage) {
            console.log("error when fetching monitoring data", errorMessage);
          }

          if (filtData.length > 0) {
            this.showCMP = true;
            this.tempStartDate = filtData[0].start_date.replace('T', ' ');
            this.tempEndDate = filtData[0].end_date.replace('T', ' ');

            this.fetchedTimePeriod.push({
              "type": "current_mp",
              "start_date": filtData[0].start_date.replace('T', ' '),
              "end_date": filtData[0].end_date.replace('T', ' '),
            });
        }

        if (filtDataTwo.length > 0) {
            this.showRMP = true;
            this.fetchedTimePeriod.push({
              "type": "revision_under_audit_mp",
              "start_date": filtDataTwo[0].start_date.replace('T', ' '),
              "end_date": filtDataTwo[0].end_date.replace('T', ' '),
            });
        }

        if (filtDataThree.length > 0) {
            this.showRIP = true;
            this.fetchedTimePeriod.push({
              "type": "revision_issue_requested_mp",
              "start_date": filtDataThree[0].start_date.replace('T', ' '),
              "end_date": filtDataThree[0].end_date.replace('T', ' '),
            });
        }
        if (this.fetchedTimePeriod.length > 0) {
            this.filter.startDate = this.fetchedTimePeriod[0].start_date;
            this.filter.endDate = this.fetchedTimePeriod[0].end_date;
        }

          if(this.showCMP || this.showRMP || this.showRIP) {
            this.showMP = true;
          } else {
            this.showMP = false; // switch if show monitoring period radio and time picker
          }

          // console.log("fetchedTimePeriod", this.fetchedTimePeriod);
        } catch (error) {
          console.error("An error occurred while fetching the monitoring period", error.message);
          let MessageBox = `<span class="moderat-meGreen-bold">Error fetching monitoring period:</span><br>
          <span class="moderat-meGreen">${error.message}</span>`;
          ElMessageBox.alert(
           MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});


          // this.showMP = false; // switch if show monitoring period radio and time picker
        }
      },

      async fetchCustomerData() {
          this.customers = await this.fromParentCustomerData.data.customers;
          this.loading = false;
      },

    /**
     * Fetches all-in-one charger data for a given customer ID.
     *
     * Description:
     * - Sets `allInOneChargerData` to null.
     * - If the `id` is not null:
     *   - Sets `chargerLoading` to true.
     *   - Creates a request body with the customer ID.
     *   - Sends a request to fetch all-in-one charger data.
     *   - Updates `allInOneChargerData` with the response data.
     *   - Processes the data asynchronously.
     * - Handles errors by logging them and redirecting to the login page if the response status is 401.
     * - Ensures that `chargerLoading` is set to false after the request is completed.
     *
     * @param {number} id - The customer ID.
     * @returns {Promise<void>} - A promise that resolves when the charger data is fetched and processed.
     */
    async fetchAllInOneChargerData(id) {
      this.allInOneChargerData = null;
      if (id != null) {
        this.chargerLoading = true;
        let body = {
          customer_id: id,
        };

        try {
          const response = await UserService.GetThreeInOneChargerData(body);
          let data = response.data;

          this.allInOneChargerData = data;
          // Process data asynchronously
          // await this.processChargerData(id, data);

        } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            this.$router.push({ path: "/" });
          }
        } finally {
          this.chargerLoading = false;
          await this.processChargerData(id, this.allInOneChargerData);
        }
      }
    },


    /**
     * Processes the charger data for a given customer ID.
     *
     * Description:
     * - Extracts the charger, port, and site data from the response.
     * - Uses `setTimeout` to process data in chunks to avoid blocking the main thread.
     * - Pushes the charger, port, and site data to their respective arrays.
     * - Calls `switchChargerDropdownData` to update the dropdown based on the selected type.
     *
     * @param {number} id - The customer ID.
     * @param {Object} data - The data object containing chargers, charger_ports, and charger_sites.
     * @returns {Promise<void>} - A promise that resolves when the data is processed.
     */
    async processChargerData(id, data) {
      const filter_charger = data.chargers;
      const filter_port = data.charger_ports;
      const filter_site = data.charger_sites;

      // Use setTimeout to process data in chunks
      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_chargers.push({
            customer_id: id,
            chargers: filter_charger,
          });
          // console.log("chargers", this.customer_chargers);

          resolve();
        }, 0);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_charger_ports.push({
            customer_id: id,
            charger_ports: filter_port,
          });
          // console.log("customer_charger_ports", this.customer_charger_ports);

          resolve();
        }, 0);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_charger_sites.push({
            customer_id: id,
            charger_sites: filter_site,
          });
          // console.log("customer_charger_sites", this.customer_charger_sites);

          resolve();
        }, 0);
      });

      this.switchChargerDropdownData(this.selectedDeleteBy);
    },
      handleCustomDate() {
        // this.filter.startDate = event;
        // this.filter.endDate = event;
        this.$emit("filterHandle", this.filter);
      },
    },
  };
  </script>

  <style scoped>
  .el-dropdown-menu {
    background-color: #0d3937 !important;
    color: white !important;
    max-width: 300px;
  }

  .el-dropdown-menu__item {
    color: white !important;
  }

  .el-dropdown-menu__item:not(.is-disabled):focus {
    background-color: #547477 !important;
  }

  .label-color > label {
    color: white !important;
    width: 80px !important;
  }
  .label-color > div > div {
    height: 100% !important;
    display: flex !important;
    align-items: center;
  }

  .el-dropdown__list > .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }

  .el-radio-button__inner {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .option-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .option-header {
    position: sticky;
    top:0;
    z-index: 1;
    font-weight: bold;
    background-color: #f2f2f2;
  }

  .option-item {
    color: var(--el-text-color-secondary);
    font-size: 13px;
    flex: 1;
    text-align: center;
    padding: 4px;
  }

  .warning-message {
  color: orangered;
  font-size: 12px;
  padding: 2px;
  border-radius: 5px;
}

.radio-label {
  color: #ffaa05;
  display: flex;
  align-items: center;
  height: 100%;
  justify-self: center;
}





  </style>
